import React, { useState } from 'react'
import Styles from 'screens/BrandKits/components/BrandVoice/BrandVoiceCard/BrandVoicePreview.module.scss'
import { HighDetailedVoice } from 'blaze-ui/icons/24'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Pressable } from '@react-aria/interactions'
import Picker from '@emoji-mart/react'
import { BaseEmoji } from 'types'
import { Button } from 'blaze-ui/Button'
import cx from 'classnames'
import { BrandVoicePreviewProps } from 'screens/BrandKits/components/BrandVoice/BrandVoiceCard/Types'

export const BrandVoicePreview = ({
  voice,
  isEmojiMenuOpen,
  onEmojiMenuOpenChange,
  onEmojiSelect,
  onRemoveEmoji,
  size = 'sm',
}: BrandVoicePreviewProps) => {
  const { color, voice_params } = voice
  const { emoji } = voice_params
  const [root, setRoot] = useState<HTMLDivElement | null>(null)

  return (
    <div
      style={{ '--background-color': color } as React.CSSProperties}
      className={cx(Styles.preview, Styles[size])}
      ref={setRoot}
    >
      <DropdownTrigger
        forceOpen={isEmojiMenuOpen}
        onOpenChange={onEmojiMenuOpenChange}
        root={root}
        restoreFocus={false}
      >
        <Pressable>
          <div className={Styles.emoji}>{emoji || <HighDetailedVoice size={36} />}</div>
        </Pressable>
        {(close) => (
          <div className={Styles.pickerContainer}>
            <Picker
              theme="light"
              previewPosition="none"
              autoFocus
              onEmojiSelect={async (emoji: BaseEmoji) => {
                onEmojiSelect(emoji)
                close()
              }}
            />
            <div className={Styles.pickerTopBar}>
              <Button
                isDisabled={!emoji}
                onPress={() => {
                  onRemoveEmoji()
                  close()
                }}
                size="sm"
                variant="secondary"
              >
                Remove Emoji
              </Button>
            </div>
          </div>
        )}
      </DropdownTrigger>
    </div>
  )
}
